import SmartModal from './smart-modal'

export default SmartModal